import React, { useState } from 'react';
import { Box, Button, ButtonProps, IconButton, SxProps } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { TP_COLORS } from '../../../constants';
import { useAppSelector } from '../../../hooks';
import {
  getTrialsState,
  toggleBookTrialModal,
} from '../../../store/V2/TrialsSlice';

const boxStyles: SxProps = {
  padding: '20px',
  borderRadius: '20px',
  background: 'linear-gradient(103.87deg, #006C9C 7.37%, #002536 100%)',
};

const buttonProps: ButtonProps = {
  sx: {
    color: '#F1F5F9',
    fontSize: '18px',
    fontWeight: '600',
    marginRight: '5px',
  },
};

const TrialClassButton: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Store
  const trialsState = useAppSelector(getTrialsState);
  const { trials } = trialsState;

  // State
  const [isVisible, setVisible] = useState(true);

  const handleButtonClick = () => {
    if (trials.upcomingTrials.length) {
      const upcomingTrial = trials.upcomingTrials[0];
      navigate(
        `${process.env.PUBLIC_URL}/portal/courses/${upcomingTrial.course._id}`
      );
    } else {
      dispatch(toggleBookTrialModal());
    }
  };
  return isVisible ? (
    <Box sx={boxStyles}>
      <Button {...buttonProps} onClick={handleButtonClick}>
        Trial Class Details
      </Button>
      <IconButton
        size="small"
        color="inherit"
        onClick={() => setVisible(false)}
      >
        <CancelIcon sx={{ color: TP_COLORS.white }} />
      </IconButton>
    </Box>
  ) : null;
};

export default TrialClassButton;
